import dayjs, { type Dayjs } from 'dayjs';

export const getCSSProperties = (el?: HTMLElement) => {
  if (!el) return {};
  const computedStyles = window.getComputedStyle(el);

  return {
    getPropFloatValue: (propName: string) => {
      const propsValue = computedStyles.getPropertyValue(propName);
      return parseFloat(propsValue) || 0;
    },
  };
};

export const ruDateToDayJs = (date: string) => {
  const splitValue = date.split('.');
  return dayjs(`${splitValue[2]}-${splitValue[1]}-${splitValue[0]}`);
};

export const dayJsToRuDate = (date: Dayjs) => {
  return date.format('DD.MM.YYYY');
};
